import { Editor } from '@tiptap/react';

export type ActiveState = {
  bold: boolean;
  italic: boolean;
  underline: boolean;
  strike: boolean;
  blockquote: boolean;
  bulletList: boolean;
  orderedList: boolean;
  link: boolean;
};

export const initialActiveState: ActiveState = {
  bold: false,
  italic: false,
  underline: false,
  strike: false,
  blockquote: false,
  bulletList: false,
  orderedList: false,
  link: false,
};

export function getActiveState(editor: Editor | null): ActiveState {
  if (!editor) {
    return initialActiveState;
  }

  return {
    bold: editor.isActive('bold'),
    italic: editor.isActive('italic'),
    underline: editor.isActive('underline'),
    strike: editor.isActive('strike'),
    blockquote: editor.isActive('blockquote'),
    bulletList: editor.isActive('bulletList'),
    orderedList: editor.isActive('orderedList'),
    link: editor.isActive('link'),
  };
}
